module.exports = __webpack_public_path__ + "static/img/img_tu.399d2d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_tu.png
// module id = Dtf9
// module chunks = 1